import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import * as FiIcons from "react-icons/fi";
import GButton from "components/ui/button/Button";

const CombosTable = ({ combosOfTimedEvent, handleDelete }) => {
  const { t } = useTranslation();
  console.log("combosOfTimedEvent", combosOfTimedEvent);

  return (
    <Box
      bg="light"
      overflow="auto"
      borderRadius={4}
      boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
    >
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>{t("pages.timedEvents.name")}</Th>
            <Th>{t("pages.timedEvents.sku")}</Th>
            <Th>{t("general.action")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {combosOfTimedEvent.map((combo, index) => (
            <Tr key={combo.TimedEventComboId}>
              <Td>{index + 1}</Td>
              <Td>{combo?.ComboName}</Td>
              <Td>{combo?.ComboSUK}</Td>
              <Td className="activeIcon">
                <GButton
                  postfixElement={<FiIcons.FiTrash2 />}
                  bg="red.600"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    bg: "none",
                    borderColor: "red.600",
                    color: "red.600",
                  }}
                  onClick={() => handleDelete(combo)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default CombosTable;
